/** Sort choices and merchant treatment labels for the direct Tests index. */
import { SHOPIFY_AUTHORED_TREATMENT_TYPES, type ShopifyAuthoredTreatmentType } from '@testfeed/shopify-contracts'
import { shopifyComponentCopy } from '@testfeed/product-language'
import type { StudySetupStatusTone } from './study-setup-lifecycle'
export type StudySetupBadgeTone = StudySetupStatusTone

export type StudySetupSort =
  | 'product-title-asc'
  | 'product-title-desc'
  | 'study-title-asc'
  | 'study-title-desc'
  | 'status-asc'
  | 'treatment-count-asc'
  | 'treatment-count-desc'
  | 'created-desc'
  | 'created-asc'

export const DEFAULT_STUDY_SETUP_SORT: StudySetupSort = 'created-desc'

const copy = shopifyComponentCopy.studySetupsPage
const TREATMENT_TYPE_LABELS: Record<ShopifyAuthoredTreatmentType, string> = {
  claim: copy.treatmentTypeClaim032,
  value_proposition: copy.treatmentTypeValueProposition033,
  description: copy.treatmentTypeDescription038,
  usage_experience: 'Usage routine',
  ingredient_proof: 'Ingredient proof',
  price: copy.treatmentTypePrice034,
  promotion_mechanic: copy.treatmentTypePromotion035,
  image_creative: copy.treatmentTypeImage036,
}

export const STUDY_TREATMENT_TYPE_OPTIONS = SHOPIFY_AUTHORED_TREATMENT_TYPES.map((value) => ({
  value,
  label: TREATMENT_TYPE_LABELS[value],
}))
